import validate from "/home/runner/work/global-main-frontend/global-main-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import lang_45from_45prefix_45global from "/home/runner/work/global-main-frontend/global-main-frontend/application/middleware/lang-from-prefix.global.ts";
import manifest_45route_45rule from "/home/runner/work/global-main-frontend/global-main-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  lang_45from_45prefix_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/middleware/auth.ts")
}